import { NimbusGridData } from '@nimbus-library/features/shared/components/nimbus-grid/domain/nimbus-grid-data';

export class NimbusGridDataView<T = any> {
  public get total() {
    return Array.isArray(this.source) ? this.source.length : this.source.total;
  }

  public get data() {
    return Array.isArray(this.source) ? this.source : this.source.data;
  }

  public constructor(private readonly source: T[] | NimbusGridData<T>) {
    this.source = source ? source : [];
  }
}
